import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Http } from '@angular/http';
import { ModalController } from 'ionic-angular';
import config from '../../config/config';

/**
 * Generated class for the AceitoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-aceito',
  templateUrl: 'aceito.html',
}) 
export class AceitoPage {
loading=null;
aceitos=null;
  constructor(
  	public navCtrl: NavController,
     public navParams: NavParams,
     public loadingCtrl: LoadingController,
    public _http: Http,
    public modalCtrl : ModalController
  	) {
  }

  ionViewDidLoad() {
    this.gettax(1);
    
  }
 carregando(){
      this.loading = this.loadingCtrl.create({
    content: 'Aguarde.'
  });
  this.loading.present();
  }
  gettax(status){
   	this.carregando();
     this._http
        .get(config.urlAPI+"formulario/tax/"+status,{})
        .map(res => res.json())
        .toPromise()
        .then(res => { 
        	this.loading.dismiss();
        	this.aceitos = res;
          console.log(res);
        }).catch(error => {
          console.log(error);

        });

	}
}



// WEBPACK FOOTER //
// ./src/pages/aceito/aceito.ts